import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TCardProductDesktop, TCardProductMobile } from '../models';

// TODO: Отрефачить компонент:
// - Название с большой буквы
// - defaultSize стоит доставать из пропсов
export const renderIcon: FC<TCardProductDesktop | TCardProductMobile> = (props, defaultSize) => {
    const { Aligner, Img, icon, styles } = props;

    return (
        <Aligner align="right">
            {icon && (
                <Img
                    alt={icon.alt}
                    className={cn(styles.external, {
                        [styles.icon]: icon.isRound,
                    })}
                    height={icon.square || icon.height || defaultSize}
                    src={icon.src}
                    width={icon.square || icon.width || defaultSize}
                />
            )}
        </Aligner>
    );
};
